var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "position-relative"
  }, [_c('div', {
    ref: "loInstructionImageRef",
    class: _vm.$style.loInstructionsImageContainer
  }, [_c('div', [_c('img', {
    class: [_vm.$style.requiredStepImage],
    attrs: {
      "src": require("@assets/images/Phase2LOStep.png"),
      "alt": "Required User Creation Complete"
    }
  })])]), _c('div', {
    class: _vm.$style.stepsOverlayContainer
  }, [_c('div', [_c('span', {
    class: [_vm.$style.stepCircle, !_vm.hoveredCircles.includes(1) ? _vm.$style.pulsatingCircle : ''],
    style: {
      'font-size': _vm.getDesiredPixelFromBaseImageSize(32) + 'px',
      'line-height': _vm.getDesiredPixelFromBaseImageSize(50) + 'px',
      height: _vm.getDesiredPixelFromBaseImageSize(50) + 'px',
      width: _vm.getDesiredPixelFromBaseImageSize(50) + 'px',
      top: _vm.getDesiredPixelFromBaseImageSize(277) + 'px',
      left: _vm.getDesiredPixelFromBaseImageSize(545) + 'px'
    },
    attrs: {
      "id": "circle1"
    },
    on: {
      "mouseover": function mouseover($event) {
        return _vm.viewCircleStep(1);
      }
    }
  }, [_vm._v("1")]), !_vm.isMobile ? _c('Tooltip', {
    attrs: {
      "icon-hide": "",
      "placement": 'top',
      "target": 'circle1',
      "theme": 'green'
    }
  }, [_vm._v(" The Legal Name of your Motto Mortgage office must show next to Authorized to Represent. ")]) : _vm._e(), _c('span', {
    class: _vm.$style.stepFrame,
    style: {
      top: _vm.getDesiredPixelFromBaseImageSize(302) + 'px',
      left: _vm.getDesiredPixelFromBaseImageSize(225) + 'px',
      width: _vm.getDesiredPixelFromBaseImageSize(307) + 'px',
      height: _vm.getDesiredPixelFromBaseImageSize(54) + 'px'
    }
  }), _c('span', {
    class: [_vm.$style.stepCircle, !_vm.hoveredCircles.includes(2) ? _vm.$style.pulsatingCircle : ''],
    style: {
      'font-size': _vm.getDesiredPixelFromBaseImageSize(32) + 'px',
      'line-height': _vm.getDesiredPixelFromBaseImageSize(50) + 'px',
      height: _vm.getDesiredPixelFromBaseImageSize(50) + 'px',
      width: _vm.getDesiredPixelFromBaseImageSize(50) + 'px',
      top: _vm.getDesiredPixelFromBaseImageSize(662) + 'px',
      left: _vm.getDesiredPixelFromBaseImageSize(758) + 'px'
    },
    attrs: {
      "id": "circle2"
    },
    on: {
      "mouseover": function mouseover($event) {
        return _vm.viewCircleStep(2);
      }
    }
  }, [_vm._v("2")]), !_vm.isMobile ? _c('Tooltip', {
    attrs: {
      "icon-hide": "",
      "placement": 'top',
      "target": 'circle2',
      "theme": 'green'
    }
  }, [_vm._v(" Authorized to Conduct Business must show \"Yes\" for the state of operation. ")]) : _vm._e(), _c('span', {
    class: _vm.$style.stepFrame,
    style: {
      top: _vm.getDesiredPixelFromBaseImageSize(687) + 'px',
      left: _vm.getDesiredPixelFromBaseImageSize(653) + 'px',
      width: _vm.getDesiredPixelFromBaseImageSize(87) + 'px',
      height: _vm.getDesiredPixelFromBaseImageSize(48) + 'px'
    }
  }), _c('span', {
    class: [_vm.$style.stepCircle, !_vm.hoveredCircles.includes(3) ? _vm.$style.pulsatingCircle : ''],
    style: {
      'font-size': _vm.getDesiredPixelFromBaseImageSize(32) + 'px',
      'line-height': _vm.getDesiredPixelFromBaseImageSize(50) + 'px',
      height: _vm.getDesiredPixelFromBaseImageSize(50) + 'px',
      width: _vm.getDesiredPixelFromBaseImageSize(50) + 'px',
      top: _vm.getDesiredPixelFromBaseImageSize(675) + 'px',
      left: _vm.getDesiredPixelFromBaseImageSize(1178) + 'px'
    },
    attrs: {
      "id": "circle3"
    },
    on: {
      "mouseover": function mouseover($event) {
        return _vm.viewCircleStep(3);
      }
    }
  }, [_vm._v("3")]), !_vm.isMobile ? _c('Tooltip', {
    attrs: {
      "icon-hide": "",
      "placement": 'top',
      "target": 'circle3',
      "theme": 'green'
    }
  }, [_vm._v(" Expand the section by clicking the [+] View Details ")]) : _vm._e(), _c('span', {
    class: _vm.$style.stepFrame,
    style: {
      top: _vm.getDesiredPixelFromBaseImageSize(687) + 'px',
      left: _vm.getDesiredPixelFromBaseImageSize(1248) + 'px',
      width: _vm.getDesiredPixelFromBaseImageSize(142) + 'px',
      height: _vm.getDesiredPixelFromBaseImageSize(46) + 'px'
    }
  })], 1), _c('div', [_c('span', {
    class: [_vm.$style.stepCircle, !_vm.hoveredCircles.includes(4) ? _vm.$style.pulsatingCircle : ''],
    style: {
      'font-size': _vm.getDesiredPixelFromBaseImageSize(32) + 'px',
      'line-height': _vm.getDesiredPixelFromBaseImageSize(50) + 'px',
      height: _vm.getDesiredPixelFromBaseImageSize(50) + 'px',
      width: _vm.getDesiredPixelFromBaseImageSize(50) + 'px',
      top: _vm.getDesiredPixelFromBaseImageSize(755) + 'px',
      left: _vm.getDesiredPixelFromBaseImageSize(278) + 'px'
    },
    attrs: {
      "id": "circle4"
    },
    on: {
      "mouseover": function mouseover($event) {
        return _vm.viewCircleStep(4);
      }
    }
  }, [_vm._v("4")]), !_vm.isMobile ? _c('Tooltip', {
    attrs: {
      "icon-hide": "",
      "placement": 'top',
      "target": 'circle4',
      "theme": 'green'
    }
  }, [_vm._v(" Status must show approved in the expanded section. ")]) : _vm._e(), _c('span', {
    class: _vm.$style.stepFrame,
    style: {
      top: _vm.getDesiredPixelFromBaseImageSize(780) + 'px',
      left: _vm.getDesiredPixelFromBaseImageSize(60) + 'px',
      width: _vm.getDesiredPixelFromBaseImageSize(202) + 'px',
      height: _vm.getDesiredPixelFromBaseImageSize(46) + 'px'
    }
  })], 1), _c('div', [_c('span', {
    class: [_vm.$style.stepCircle, !_vm.hoveredCircles.includes(5) ? _vm.$style.pulsatingCircle : ''],
    style: {
      'font-size': _vm.getDesiredPixelFromBaseImageSize(32) + 'px',
      'line-height': _vm.getDesiredPixelFromBaseImageSize(50) + 'px',
      height: _vm.getDesiredPixelFromBaseImageSize(50) + 'px',
      width: _vm.getDesiredPixelFromBaseImageSize(50) + 'px',
      top: _vm.getDesiredPixelFromBaseImageSize(832) + 'px',
      left: _vm.getDesiredPixelFromBaseImageSize(420) + 'px'
    },
    attrs: {
      "id": "circle5"
    },
    on: {
      "mouseover": function mouseover($event) {
        return _vm.viewCircleStep(5);
      }
    }
  }, [_vm._v("5")]), !_vm.isMobile ? _c('Tooltip', {
    attrs: {
      "icon-hide": "",
      "placement": 'top',
      "target": 'circle5',
      "theme": 'green'
    }
  }, [_vm._v(" Your Motto Mortgage Legal Name, NMLS ID, and Start Date must be listed under Currently Authorized to Represent. ")]) : _vm._e(), _c('span', {
    class: _vm.$style.stepFrame,
    style: {
      top: _vm.getDesiredPixelFromBaseImageSize(866) + 'px',
      left: _vm.getDesiredPixelFromBaseImageSize(60) + 'px',
      width: _vm.getDesiredPixelFromBaseImageSize(348) + 'px',
      height: _vm.getDesiredPixelFromBaseImageSize(83) + 'px'
    }
  })], 1)]), _c('div', {
    class: _vm.$style.stepsMobile
  }, [_c('div', [_c('span', {
    class: _vm.$style.stepCircleMobile
  }, [_vm._v("1")]), _c('p', [_vm._v(" The Legal Name of your Motto Mortgage office must show next to Authorized to Represent.")])]), _c('div', [_c('span', {
    class: _vm.$style.stepCircleMobile
  }, [_vm._v("2")]), _c('p', [_vm._v(" Authorized to Conduct Business must show \"Yes\" for the state of operation.")])]), _c('div', [_c('span', {
    class: _vm.$style.stepCircleMobile
  }, [_vm._v("3")]), _c('p', [_vm._v(" Expand the section by clicking the [+] View Details")])]), _c('div', [_c('span', {
    class: _vm.$style.stepCircleMobile
  }, [_vm._v("4")]), _c('p', [_vm._v(" Status must show approved in the expanded section.")])]), _c('div', [_c('span', {
    class: _vm.$style.stepCircleMobile
  }, [_vm._v("5")]), _c('p', [_vm._v(" Your Motto Mortgage Legal Name, NMLS ID, and Start Date must be listed under Currently Authorized to Represent. ")])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }